import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";
import { HTTPS } from "../../shared/constants";

interface Questionaries {
  questionariesData: object;
  curQuestionariesEditData: any;
  totalPageCount: number;
  totalData: number;
  error: string;
}

const initialArgs: Questionaries = {
  questionariesData: [],
  curQuestionariesEditData: {},
  totalPageCount: 0,
  totalData: 17,
  error: "",
};

const reducer = (state: Questionaries, action: Questionaries) => {
  return { ...state, ...action };
};

const useQuestionaries = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getQuestionaries = async (
    page: string,
    listPerPage: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/questionnaires?page=${page}&listPerPage=${listPerPage}&search=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          questionariesData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createQuestionaries = async (param: any) => {
    const paramObj = {
      title: param.title,
      subTitle: param.subTitle,
      sequence: param.sequence,
      validationCount: param.validationCount,
      skill: param.skill,
      slug: param.slug,
      tags: param.tags,
    };
    try {
      const result: any = await api.post("/api/v1/questionnaires", paramObj);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Questionaries has been Added Successfully");
        setState({ ...state, questionariesData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Edit
  const editQuestionaries = async (questionariesId: string) => {
    try {
      const result: any = await api.get(
        `/api/v1/questionnaires/${questionariesId}`,
      );

      if (result.data.status) {
        setState({ ...state, curQuestionariesEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //For Update
  const updateQuestionaries = async (param: any) => {
    const paramObj = {
      ...param,
      sequence: parseFloat(param.sequence),
    };

    try {
      const result: any = await api.post(
        `/api/v1/questionnaires/${param.id}`,
        paramObj,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        //toast.dismiss(updateInsituteToast);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const deleteQuestionaries = async (questionariesId: number) => {
    try {
      const { status } = await api.delete(
        `/api/v1/questionnaires/delete?questionId=${questionariesId}`,
      );

      if (status === HTTPS.OK) {
        toast.success("Questionaries has been deleted successfully");
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      toast.error("Error while deleting Questionaries");
      return false;
    }
  };
  return {
    getQuestionaries,
    createQuestionaries,
    editQuestionaries,
    updateQuestionaries,
    deleteQuestionaries,
    ...state,
  };
};

export default useQuestionaries;
